<template>
  <div id="myChats">
    <f7-list media-list v-if="myChatLoading" style="top: 42px">
      <f7-list-item
        v-if="myChatLoading && user.isEmployee"
        v-for="n in 15"
        :key="n"
        :class="`skeleton-text skeleton-effect-blink`"
        title="Full Name"
        after="1 day ago"
        text="Lorem ipsum dolor sit amet."
      >
        <f7-skeleton-block
          style="width: 40px; height: 40px; border-radius: 50%"
          slot="media"
        ></f7-skeleton-block>
      </f7-list-item>
    </f7-list>
    <f7-list media-list v-if="!myChatLoading && !isSearch" style="top: 42px">
      <f7-block-title v-if="!myChatsList.length" class="notfound"
        >Contacts not found!</f7-block-title
      >
      <li
        v-for="(user, index) in myChatsList"
        :key="index"
        :class="{
          read: user.is_read && user.from_client_id > 0,
          'no-read': !user.is_read && user.from_client_id > 0,
          from_client: user.from_client_id > 0,
          from_employee: user.from_employee_id > 0,
        }"
      >
        <a
          @click="active(user.client.client_id, user)"
          :href="
            '/conversation/' +
            user.client.client_id +
            '/?user=' +
            JSON.stringify(clientDetail(user))
          "
        >
          <div class="item-content">
            <div class="item-media">
              <i
                v-bind:class="{
                  online: user.online_now,
                  offline: !user.online_now,
                }"
              ></i>
              <img
                v-if="user.client && user.client.photo_url"
                v-bind:src="user.client.photo_url"
                :alt="
                  user.client.first_name ? user.client.first_name : 'Unknown'
                "
                style="width: 40px; height: 40px; border-radius: 50%"
                slot="media"
              />
              <img
                v-else
                src="../../../assets/nophoto.png"
                :alt="
                  user.client.first_name
                    ? user.client.first_name
                    : 'user.client.first_name'
                "
                style="width: 40px; height: 40px; border-radius: 50%"
                slot="media"
              />
            </div>
            <div class="item-inner">
              <div class="item-title-row">
                <a
                  v-on:click="openLink(user.client.client_id)"
                  :title="
                    fullTitle(
                      user.client.first_name,
                      user.client.last_name,
                      user.client.age,
                      user.client.gender
                    )
                  "
                >
                  <div class="item-title">
                    {{ getName(user.client.first_name, user.client.last_name) }}
                    <b>{{
                      getAgeGender(user.client.age, user.client.gender)
                    }}</b>
                  </div>
                </a>
                <div class="item-after">
                  <span>{{ user.sent_time | timeAgo }}</span>
                </div>
              </div>
              <div
                v-if="user.unread_count && user.unread_count > 0"
                style="position: absolute; right: 10px; top: 30px; z-index: 2"
              >
                <span class="badge color-green">{{ user.unread_count }}</span>
              </div>
              <div
                class="item-text"
                v-if="user.photo_url.length > 0"
                style="display: flex"
              >
                <!-- <i class="material-icons" style="font-size:19px">camera_alt</i> -->
                <img
                  src="../../../assets/camera.png"
                  style="border: none !important; opacity: 0.5; height: 20px"
                />
                <span>Photo</span>
              </div>
              <div class="item-text" else>{{ user.msg }}</div>
              <!-- <div class="statusDiv" style="margin-left: -70px">
                <small class="status"
                  >({{ user.client.dated_count }}
                  {{
                    user.client.dated_count == 0 || user.client.dated_count > 1
                      ? "dates arranged"
                      : "date arranged"
                  }}
                  {{
                    user.client.date_credits ? user.client.date_credits : 0
                  }}
                  Date Credits,
                  {{ user.client.paidCount ? user.client.paidCount : 0 }}
                  payments
                  )</small
                >
              </div> -->
              <div class="statusDiv" style="margin-left: -70px">
                <small
                  class="status"
                  :title="
                    user.client.total_paid_amount
                      ? user.client.total_paid_amount
                      : 'HK$0'
                  "
                >
                  <b
                    class="membershipName"
                    v-bind:style="{
                      color: user.client.membership_level.color_code,
                    }"
                    v-if="user.client.membership_level"
                    >({{ user.client.membership_level.description }})</b
                  >
                  ({{ user.client.dated_count }}
                  {{
                    user.client.dated_count == 0 || user.client.dated_count > 1
                      ? "dates arranged"
                      : "date arranged"
                  }})
                  {{ user.client.status ? user.client.status.description : "" }}
                </small>
              </div>

              <!-- <small
                :class="{
                  read: user.is_read && user.from_client_id,
                  'no-read': !user.is_read && user.from_client_id,
                  from_client: user.from_client_id != null,
                  from_employee: user.from_employee_id != null,
                }"
              >
                <i class="fas fa-laptop"></i>
                {{ user.client.device_id | deviceFilter }}
              </small> -->
              <small
                :class="{
                  read: user.is_read && user.from_client_id,
                  'no-read': !user.is_read && user.from_client_id,
                  from_client: user.from_client_id != null,
                  from_employee: user.from_employee_id != null,
                }"
              >
                <!-- <img
                  src="../../../assets/dateArrangedWhite.png"
                  class="dateArranged"
                  v-if="user.from_client_id!=null"
                />
                <img src="../../../assets/dateArranged.png" class="dateArranged" v-else />
                {{user.client.dated_count}} {{(user.client.dated_count==0 ||user.client.dated_count >1)?'dates arranged':'date arranged' }} -->
              </small>
              <div class="newRow" style="margin-left: -70px">
                <!-- <small
                  class="last_active relationship"
                  :title="
                    user.client.relationship_managers
                      ? user.client.relationship_managers
                          .map((a) => a.name)
                          .join(',')
                      : 'NONE'
                  "
                  >Personal Matchmaker:
                  {{
                    user.client.relationship_managers.length
                      ? user.client.relationship_managers
                          .map((a) => a.name)
                          .join(",")
                      : "NONE"
                  }}</small
                > -->
                <small class="last_active" :title="user.client.last_active_time"
                  >Last Active:
                  {{ user.client.last_active_time | timeActivity }} ({{
                    user.client.relationship_managers.length
                      ? user.client.relationship_managers
                          .map((a) => a.name)
                          .join(",")
                      : "NONE"
                  }})</small
                >
                <!-- <small class="last_active" v-if="user.client.lastConsultation"
                  >Last Consultation:
                  {{
                    user.client.lastConsultation.consultation_time | formatDates
                  }}
                  -
                  {{
                    user.client.lastConsultation.consultation_status
                      ? user.client.lastConsultation.consultation_status
                          .description
                      : ""
                  }}
                  (met by
                  {{
                    user.client.lastConsultation.sales_employee
                      ? user.client.lastConsultation.sales_employee.first_name
                      : ""
                  }}
                  {{
                    user.client.lastConsultation.sales_employee
                      ? user.client.lastConsultation.sales_employee.last_name
                      : ""
                  }})</small
                >
                <small class="last_active" v-else>
                  Last Consultation:
                  <b class="none">NONE</b>
                </small> -->
              </div>
            </div>
          </div>
        </a>
      </li>
    </f7-list>
  </div>
</template>
<style scoped src="../../../assets/css/leftnavChat.css">
</style>

<script>
import { mixin } from "../../../utils/mixin";
export default {
  name: "myChats",
  mixins: [mixin],
  props: ["isSearch", "myChatLoading", "user", "myChatsList"],
  data() {
    return {};
  },
  methods: {
    active(id, user) {
      let data = {
        id,
        user,
      };
      this.$emit("activeUser", data);
    },
  },
};
</script>
